import React from 'react';

const LogoMoonbeam: React.FC = () => {
    return (
       <img width={127} height={44} src='img-logo-awa-black.png'/>
    );
}

export default LogoMoonbeam;
